import { ConsumerTokens } from "@type/tokens";
import { baseTokens } from "./baseTokens";

export { baseTokens } from "./baseTokens";
export { internalTokens } from "./internalTokens";

export const defaultConsumerTokens: ConsumerTokens = baseTokens;
